import { render, staticRenderFns } from "./backBtn.vue?vue&type=template&id=073ed179&scoped=true"
var script = {}
import style0 from "./backBtn.vue?vue&type=style&index=0&id=073ed179&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073ed179",
  null
  
)

export default component.exports